var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgLayout = function SvgLayout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47 14.82H17c-1.21 0-2.2.99-2.2 2.2v10.99c0 1.21.99 2.2 2.2 2.2h30c1.21 0 2.2-.99 2.2-2.2V17.03c0-1.21-.99-2.2-2.2-2.2Zm-.2 12.98H17.2V17.22h29.6V27.8ZM29 33.8H17c-1.23 0-2.2 1.11-2.2 2.53v10.32c0 1.42.97 2.53 2.2 2.53h12c1.23 0 2.2-1.11 2.2-2.53V36.33c0-1.42-.97-2.53-2.2-2.53Zm-.2 12.85c0 .05 0 .1-.02.13H17.21s-.02-.08-.02-.13V36.33c0-.05 0-.1.01-.13h11.57s.02.08.02.13v10.32ZM47 33.8H35c-1.23 0-2.2 1.11-2.2 2.53v10.32c0 1.42.97 2.53 2.2 2.53h12c1.23 0 2.2-1.11 2.2-2.53V36.33c0-1.42-.97-2.53-2.2-2.53Zm-.2 12.85c0 .05 0 .1-.02.13H35.21s-.02-.08-.02-.13V36.33c0-.05 0-.1.01-.13h11.57s.02.08.02.13v10.32Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLayout);
export default ForwardRef;